import { render, staticRenderFns } from "./ViewEvents.vue?vue&type=template&id=eb95ec90&scoped=true&"
import script from "./ViewEvents.vue?vue&type=script&lang=js&"
export * from "./ViewEvents.vue?vue&type=script&lang=js&"
import style0 from "./ViewEvents.vue?vue&type=style&index=0&id=eb95ec90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb95ec90",
  null
  
)

export default component.exports